import {useEffect} from 'react';

export default function useDefaultPractitioner(practitioners, setSelectedPractitionerId) {
  useEffect(() => {
    if (!practitioners || practitioners.length === 0) return;

    setSelectedPractitionerId(prev => {
      if (prev) return prev;

      return practitioners[0].practitioner_id;
    });
  }, [practitioners, setSelectedPractitionerId]);
}
